import { __decorate, __metadata } from "tslib";
import { IsUndefinable, nameOf } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { Equals, IsArray, IsBoolean, IsNotEmpty, IsNumber, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderElementTypeEnum } from '../enum';
import { OrderExposeGroup } from '../interface';
import { ReadBaseOrderSelectionDto } from './ReadBaseOrderSelectionDto';
import { ReadOrderItemDto } from './ReadOrderItemDto';
import { ReadOrderSelectionDto } from './ReadOrderSelectionDto';
import { ReadOrderSelectionGroupDto } from './ReadOrderSelectionGroupDto';
let ReadOrderPropertyDto = class ReadOrderPropertyDto extends ReadOrderItemDto {
};
__decorate([
    ApiProperty({ enum: OrderElementTypeEnum, default: OrderElementTypeEnum.PROPERTY }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    Equals(OrderElementTypeEnum.PROPERTY, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPropertyDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ oneOf: refs(ReadOrderSelectionDto, ReadOrderSelectionGroupDto), isArray: true }),
    Type(() => ReadBaseOrderSelectionDto, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: nameOf('type'),
            subTypes: [
                { value: ReadOrderSelectionDto, name: OrderElementTypeEnum.SELECTION },
                { value: ReadOrderSelectionGroupDto, name: OrderElementTypeEnum.SELECTION_GROUP },
            ],
        },
    }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], ReadOrderPropertyDto.prototype, "selections", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 1 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderPropertyDto.prototype, "selections_min", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPropertyDto.prototype, "isHidden", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPropertyDto.prototype, "pos_guid", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, description: 'should be always true', example: true }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], ReadOrderPropertyDto.prototype, "selected", void 0);
ReadOrderPropertyDto = __decorate([
    ApiExtraModels(ReadOrderSelectionDto, ReadOrderSelectionGroupDto)
], ReadOrderPropertyDto);
export { ReadOrderPropertyDto };
//# sourceMappingURL=ReadOrderPropertyDto.js.map